import { Component, OnInit, ViewChild } from '@angular/core';
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { CustomDropdownComponent } from "../../../../shared/components/custom-dropdown/custom-dropdown.component";
import { ElectricityCostsChartComponent } from "../../charts/electricity/electricity-costs-chart/electricity-costs-chart.component";
import { ComparisonYearComponent } from "../../components/comparison-year/comparison-year.component";
import { ConsumptionAndCostsChartComponent } from "../../charts/electricity/consumption-and-costs-chart/consumption-and-costs-chart.component";
import { ConsumptionAndCostsDoughnutChartComponent } from "../../charts/electricity/consumption-and-costs-doughnut-chart/consumption-and-costs-doughnut-chart.component";
import { ConsumptionAndCostsRightChartComponent } from "../../charts/electricity/consumption-and-costs-right-chart/consumption-and-costs-right-chart.component";
import { CostAnalysisChartComponent } from "../../charts/electricity/cost-analysis-chart/cost-analysis-chart.component";
import { CostPerKwhChartComponent } from "../../charts/electricity/cost-per-kwh-chart/cost-per-kwh-chart.component";
import { CostBreakDownChartComponent } from "../../charts/electricity/cost-break-down-chart/cost-break-down-chart.component";
import { InvoiceCheckedComponent } from "../../components/invoice-checked/invoice-checked.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";
import { SubscriptionService } from '../../../../core/services/subscription.service';
import { Location } from '../../../../core/interfaces/location';
import { LocationService } from '../../../../core/api/location.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule } from '@angular/common';
import { ElectricityConsumptionAndCosts, ElectricityPeriodCostAnalysisGet, YearlyOverview } from '../../../../core/interfaces/dashboard-interfaces';
import { DashboardService } from '../../../../core/api/dashboard.service';
import { ElectricityCostsAveragesComponent } from "../../charts/electricity/electricity-costs-averages/electricity-costs-averages.component";
import { combineLatest, Subscription } from 'rxjs';
import { UserDataService } from '../../../../core/services/user-data.service';
import { CompleteEnergyProfileComponent } from "../../components/overview/complete-energy-profile/complete-energy-profile.component";
import { FlexUpgradeComponent } from "../../components/flex-upgrade/flex-upgrade.component";
import { NoMembershipPopupComponent } from "../../../../shared/components/no-membership-popup/no-membership-popup.component";
import { NoDataMessageComponent } from "../../components/no-data-message/no-data-message.component";
import { ExtractionOngoingPopupComponent } from '../../../../shared/components/extraction-ongoing-popup/extraction-ongoing-popup.component';
import { CommodityType } from '../../../../core/interfaces/invoice-interfaces';
import { FileExtractionService } from '../../../../core/services/file_extraction_service';

@Component({
  selector: 'app-electricity',
  standalone: true,
  imports: [DesktopSidebarComponent, DesktopTopbarComponent, MobileTopbarComponent, TabButtonComponent, CustomDropdownComponent, ElectricityCostsChartComponent, ComparisonYearComponent, ConsumptionAndCostsChartComponent, ConsumptionAndCostsDoughnutChartComponent, ConsumptionAndCostsRightChartComponent, CostAnalysisChartComponent, CostPerKwhChartComponent, CostBreakDownChartComponent, TranslocoPipe, CustomFooterComponent, ToastComponent, FormsModule, CalendarModule, CommonModule, ElectricityCostsAveragesComponent, CompleteEnergyProfileComponent, FlexUpgradeComponent, NoMembershipPopupComponent, NoDataMessageComponent, ExtractionOngoingPopupComponent],
  templateUrl: './electricity.component.html',
  styleUrl: './electricity.component.css'
})
export class ElectricityComponent implements OnInit {
  get hasPlusSubscription(): boolean {
    return this.subscriptionService.hasPlusSubscription();
  }

  currentYear = new Date().getFullYear();

  get showUpgradeElectricityCosts(): boolean {
    if (this.electricityCostsDataYear < this.currentYear) {
      return false;
    }
    return this.subscriptionService.showForecastUpgradeComponents();
  }

  get showUpgradeConsumption(): boolean {
    if (this.consumptionAndCostsDataYear < this.currentYear) {
      return false;
    }
    return this.subscriptionService.showForecastUpgradeComponents();
  }

  get showUpgradeGeneral(): boolean {
    return this.subscriptionService.showForecastUpgradeComponents();
  }

  get showDummyData(): boolean {
    return (!this.subscriptionService.hasPlusSubscription() || !this.userData.getUser()?.company?.has_files);
  }

  get isExtractionOngoing(): boolean {
    return this.fileExtractionService.isExtractionOngoing();
  }

  // Show no data dialog
  noDataDialogShowCosts: boolean = false;
  noDataDialogShowConsumptionCosts: boolean = false;

  // Dropdown Menu
  locationsDropdownOptions: string[] = [];
  selectedLocationDropdown: number | undefined;

  listOfLocations: Location[] = [];
  allLocationsTranslation: string = "All Locations";

  // Forecast max date
  electricityForecastMaxDate: Date = new Date();

  // Electricity costs date
  electricityCostsDate: Date | undefined = new Date();
  electricityCostsComparisonDate: Date | undefined = undefined;

  electricityCostsDataResponse: YearlyOverview | null = null;
  electricityCostsDataLoaded: boolean = false;
  electricityCostsDataYear: number = 0;

  electricityCostsComparisonDataResponse: YearlyOverview | null = null;
  electricityCostsComparisonDataLoaded: boolean = false;
  electricityCostsComparisonDataYear: number = 0;

  averagePricePerKWhData: (number | null)[] = new Array(12).fill(null);
  forecastedStartMonth: number | null = null;
  invoiceAmountActualData: (number | null)[] = new Array(12).fill(0);
  invoiceAmountForecastData: (number | null)[] = new Array(12).fill(0);

  compariosonCurrentyear: number = 0;
  compariosonCurrentlastFullMonthCost: number = 0;
  compariosonCurrentlastFullMonthkWh: number = 0;
  compariosonCurrentyearToDateCost: number = 0;
  compariosonCurrentyearToDatekWh: number = 0;
  compariosonCurrentforecastFullYearCost: number = 0;
  compariosonCurrentforecastFullYearkWh: number = 0;

  compariosonOlderyear: number = 0;
  compariosonOlderlastFullMonthCost: number = 0;
  compariosonOlderlastFullMonthkWh: number = 0;
  compariosonOlderyearToDateCost: number = 0;
  compariosonOlderyearToDatekWh: number = 0;
  compariosonOlderforecastFullYearCost: number = 0;
  compariosonOlderforecastFullYearkWh: number = 0;

  // Consumption and costs
  consumptionAndCostsDate: Date | undefined = new Date();
  consumptionAndCostsDataResponse: ElectricityConsumptionAndCosts | null = null;
  consumptionAndCostsDataLoaded: boolean = false;
  consumptionAndCostsDataYear: number = 0;

  consumptionF1: (number | null)[] = new Array(12).fill(0);
  consumptionF2: (number | null)[] = new Array(12).fill(0);
  consumptionF3: (number | null)[] = new Array(12).fill(0);
  consumptionF1Forecast: (number | null)[] = new Array(12).fill(0);
  consumptionF2Forecast: (number | null)[] = new Array(12).fill(0);
  consumptionF3Forecast: (number | null)[] = new Array(12).fill(0);
  costsActual: (number | null)[] = new Array(12).fill(null);
  costsForecast: (number | null)[] = new Array(12).fill(null);
  kWhActual: (number | null)[] = new Array(12).fill(null);
  kWhForecast: (number | null)[] = new Array(12).fill(null);
  showForecastData: boolean = true;

  cacd_labels: string[] = ['F1', 'F2', 'F3'];
  cacd_showData: number[] = [0, 0, 0];
  cacd_totalConsumption: number = 0;

  cacr_f1data: (number | null)[] = [null, null, null];
  cacr_f2data: (number | null)[] = [null, null, null];
  cacr_f3data: (number | null)[] = [null, null, null];
  cacr_f1eurperkwh: number = 0.0;
  cacr_f2eurperkwh: number = 0.0;
  cacr_f3eurperkwh: number = 0.0;

  // Cost analysis
  costAnalysisYear: Date | undefined = new Date();
  costAnalysisMonth: Date | undefined = undefined;

  costAnalysisDataResponse: ElectricityPeriodCostAnalysisGet | null = null;
  costAnalysisDataLoaded: boolean = false;
  costAnalysisDataYear: number = 0;
  costAnalysisDataMonth: number | null = null;

  costAnalysisPervoiusPeriodDataResponse: ElectricityPeriodCostAnalysisGet | null = null;
  costAnalysisPervoiusPeriodDataLoaded: boolean = false;
  costAnalysisPervoiusPeriodDataYear: number = 0;
  costAnalysisPervoiusPeriodDataMonth: number | null = null;

  capd_lineCostTrendData: number[] = [0, 0];
  capd_barkWhData: number[] = [0, 0];
  capd_inputedPeriods: string[] | undefined = undefined;
  capd_kwhDifference: number = 0;
  capd_costDifference: number = 0;

  months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  materialCostsDifferenceSign: string = '+';
  materialCostsDifference: number = 0;
  tmsDifferenceSign: string = '+';
  tmsDifference: number = 0;
  taxesDifferenceSign: string = '+';
  taxesDifference: number = 0;
  additionalChargesDifferenceSign: string = '+';
  additionalChargesDifference: number = 0;
  previousPeriodCostPerKwh: number = 0;
  currentPeriodCostPerKwh: number = 0;
  inputedPeriods: string[] | undefined = undefined;

  noDataPopUp: boolean = false;

  costBreakdownData: number[] = new Array(6).fill(0);
  totalPricePerUnit: number = 0;

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Minimum year for year pickers
  datePickerMinYear: Date = new Date(2024, 0, 1);

  extractionCompletedSubscription?: Subscription;

  constructor(private translocoService: TranslocoService, private subscriptionService: SubscriptionService, private locationService: LocationService, private apiError: ApiErrorService, private dashboardService: DashboardService, private userData: UserDataService, private fileExtractionService: FileExtractionService) { }

  ngOnInit(): void {
    this.translocoService.selectTranslate('dashboard.all_locations').subscribe((translation) => {
      this.locationsDropdownOptions = [translation];
      this.allLocationsTranslation = translation;
    });
    this.selectedLocationDropdown = 0;

    const monthKeys = [
      'shared.months.jan', 'shared.months.feb', 'shared.months.mar',
      'shared.months.apr', 'shared.months.may', 'shared.months.jun',
      'shared.months.jul', 'shared.months.aug', 'shared.months.sep',
      'shared.months.oct', 'shared.months.nov', 'shared.months.dec'
    ];

    combineLatest(monthKeys.map((key) => this.translocoService.selectTranslate(key)))
      .subscribe((translations) => {
        this.months = translations;
      });

    this.refreshDashboardData()

    this.fileExtractionService.startCheckingExtractionStatus(CommodityType.electricity);

    this.extractionCompletedSubscription = this.fileExtractionService
      .onExtractionCompleted()
      .subscribe(() => {
        this.refreshDashboardData();
      });
  }

  refreshDashboardData(): void {
    this.loadLocationsData();
    this.loadElectricityCostsData();
    this.loadConsumptionAndCostData();
    this.loadCostAnalysisData();

    // Set max year date for year pickers
    this.setMaxYearDate();
  }

  ngOnDestroy(): void {
    this.extractionCompletedSubscription?.unsubscribe();
    this.fileExtractionService.stopCheckingExtractionStatus();
  }


  populateLocationsDropdown() {
    this.locationsDropdownOptions = [this.allLocationsTranslation];

    const currentSelection = this.selectedLocationDropdown;

    if (this.selectedLocationDropdown === undefined) {
      this.selectedLocationDropdown = 0;
    }

    for (let i = 0; i < this.listOfLocations.length; i++) {
      const location = this.listOfLocations[i];
      const locationString = `${location.street ?? ''} ${location.number ?? ''}, ${location.postal_code ?? ''} ${location.city ?? ''}`;
      this.locationsDropdownOptions.push(locationString);
    }

    if (currentSelection !== undefined && currentSelection > 0) {
      if (currentSelection > this.listOfLocations.length) {
        this.selectedLocationDropdown = 0;
      }
    }
  }

  loadLocationsData() {
    this.locationService.getLocations().subscribe({
      next: (response) => {
        if (response) {
          this.listOfLocations = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
        this.populateLocationsDropdown();
      }
    });
  }

  openComparisonYearSelect() {
    this.electricityCostsComparisonDate = new Date();
    this.electricityCostsComparisonDate.setFullYear(this.electricityCostsComparisonDate.getFullYear() - 1);
    this.loadElectricityComparisonCostsData();
  }

  loadElectricityCostsData() {
    if (this.electricityCostsDate?.getFullYear() === null || this.electricityCostsDate?.getFullYear() === undefined) {
      this.electricityCostsDate = new Date();
    }

    this.electricityCostsDataYear = this.electricityCostsDate?.getFullYear();
    const location = (this.selectedLocationDropdown === 0) ? null : this.listOfLocations[(this.selectedLocationDropdown! - 1)].id;
    this.dashboardService.getElectricityOverview(this.electricityCostsDataYear, location).subscribe({
      next: (response) => {
        if (response) {
          this.electricityCostsDataResponse = response;

          // Populate charts
          this.populateElectricityCostsData();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.electricityCostsDataLoaded = false;

        // Populate charts
        this.populateElectricityCostsData();
      },
      complete: () => {
        // Mark api loading as completed
        this.electricityCostsDataLoaded = true;
      }
    });
  }

  populateElectricityCostsData(): void {
    this.averagePricePerKWhData = new Array(12).fill(null);
    this.invoiceAmountActualData = new Array(12).fill(0);
    this.invoiceAmountForecastData = new Array(12).fill(0);
    this.forecastedStartMonth = null;

    if (!this.electricityCostsDataResponse ||
      !this.electricityCostsDataResponse.total_costs.length ||
      !this.electricityCostsDataResponse.total_consumption.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const dataYear = this.electricityCostsDataYear;

    this.electricityCostsDataResponse.total_costs.forEach(monthData => {
      const monthIndex = monthData.month - 1;

      if (dataYear < currentYear || (dataYear === currentYear && monthData.month < currentMonth)) {
        this.invoiceAmountActualData[monthIndex] = monthData.actual_value ?? 0;

      } else {
        this.invoiceAmountForecastData[monthIndex] = monthData.forecasted_value ?? 0;
      }
    });

    this.electricityCostsDataResponse.total_consumption.forEach(monthData => {
      const monthIndex = monthData.month - 1;

      const actualCost = this.invoiceAmountActualData[monthIndex] ?? 0;
      const forecastCost = this.invoiceAmountForecastData[monthIndex] ?? 0;
      const actualConsumption = monthData.actual_value ?? 0;
      const forecastConsumption = monthData.forecasted_value ?? 0;

      if (dataYear < currentYear || (dataYear === currentYear && monthData.month < currentMonth)) {
        // Actual average price per kWh
        this.averagePricePerKWhData[monthIndex] =
          actualCost > 0 && actualConsumption > 0
            ? actualCost / actualConsumption
            : null;

      } else {
        if (this.forecastedStartMonth === null) {
          this.forecastedStartMonth = monthIndex;
        }
        // Forecasted values for current and future months
        this.averagePricePerKWhData[monthIndex] =
          forecastCost > 0 && forecastConsumption > 0
            ? forecastCost / forecastConsumption
            : null;
      }
    });

    this.noDataDialogShowCosts = [
      ...this.invoiceAmountActualData,
      ...this.invoiceAmountForecastData,
      ...this.averagePricePerKWhData
    ].every(value => value === 0 || value === null);

    this.populateComparisonCurrent();
  }

  populateComparisonCurrent(): void {
    this.compariosonCurrentyear = this.electricityCostsDataYear;
    this.compariosonCurrentlastFullMonthCost = 0;
    this.compariosonCurrentlastFullMonthkWh = 0;
    this.compariosonCurrentyearToDateCost = 0;
    this.compariosonCurrentyearToDatekWh = 0;
    this.compariosonCurrentforecastFullYearCost = 0;
    this.compariosonCurrentforecastFullYearkWh = 0;

    if (!this.electricityCostsDataResponse ||
      !this.electricityCostsDataResponse.total_costs.length ||
      !this.electricityCostsDataResponse.total_consumption.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let lastFullMonthIndexComparison = currentMonth - 1;

    // Jan remains Jan
    if (lastFullMonthIndexComparison < 1) {
      lastFullMonthIndexComparison = 1;
    }

    this.electricityCostsDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualCost = monthData.actual_value ?? 0;
      const forecastCost = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentyearToDateCost += actualCost;
      }

      if (this.compariosonCurrentyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentforecastFullYearCost += actualCost;
      } else {
        this.compariosonCurrentforecastFullYearCost += forecastCost;
      }
    });

    this.electricityCostsDataResponse.total_consumption.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualkWh = monthData.actual_value ?? 0;
      const forecastkWh = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentyearToDatekWh += actualkWh;
      }

      if (this.compariosonCurrentyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentforecastFullYearkWh += actualkWh;
      } else {
        this.compariosonCurrentforecastFullYearkWh += forecastkWh;
      }

      if (monthIndex === lastFullMonthIndexComparison) {
        this.compariosonCurrentlastFullMonthCost = this.electricityCostsDataResponse?.total_costs[monthIndex - 1]?.actual_value ?? 0;
        this.compariosonCurrentlastFullMonthkWh = this.electricityCostsDataResponse?.total_consumption[monthIndex - 1]?.actual_value ?? 0;
      }
    });
  }

  loadElectricityComparisonCostsData() {
    if (this.electricityCostsComparisonDate?.getFullYear() === null || this.electricityCostsComparisonDate?.getFullYear() === undefined) {
      this.electricityCostsComparisonDate = new Date();
    }

    this.electricityCostsComparisonDataYear = this.electricityCostsComparisonDate?.getFullYear();
    const location = (this.selectedLocationDropdown === 0) ? null : this.listOfLocations[(this.selectedLocationDropdown! - 1)].id;
    this.dashboardService.getElectricityOverview(this.electricityCostsComparisonDataYear, location).subscribe({
      next: (response) => {
        if (response) {
          this.electricityCostsComparisonDataResponse = response;

          // Populate charts
          this.populateComparison();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.electricityCostsComparisonDataLoaded = false;

        // Populate charts
        this.populateComparison();
      },
      complete: () => {
        // Mark api loading as completed
        this.electricityCostsComparisonDataLoaded = true;
      }
    });
  }

  locationChange() {
    this.loadElectricityCostsData();
    this.loadElectricityComparisonCostsData()
  }

  populateComparison(): void {
    this.compariosonOlderyear = this.electricityCostsComparisonDataYear;
    this.compariosonOlderlastFullMonthCost = 0;
    this.compariosonOlderlastFullMonthkWh = 0;
    this.compariosonOlderyearToDateCost = 0;
    this.compariosonOlderyearToDatekWh = 0;
    this.compariosonOlderforecastFullYearCost = 0;
    this.compariosonOlderforecastFullYearkWh = 0;

    if (!this.electricityCostsComparisonDataResponse ||
      !this.electricityCostsComparisonDataResponse.total_costs.length ||
      !this.electricityCostsComparisonDataResponse.total_consumption.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let lastFullMonthIndexComparison = currentMonth - 1;

    // Jan remains Jan
    if (lastFullMonthIndexComparison < 1) {
      lastFullMonthIndexComparison = 1;
    }

    this.electricityCostsComparisonDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualCost = monthData.actual_value ?? 0;
      const forecastCost = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderyearToDateCost += actualCost;
      }

      if (this.compariosonOlderyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderforecastFullYearCost += actualCost;
      } else {
        this.compariosonOlderforecastFullYearCost += forecastCost;
      }
    });

    this.electricityCostsComparisonDataResponse.total_consumption.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualkWh = monthData.actual_value ?? 0;
      const forecastkWh = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderyearToDatekWh += actualkWh;
      }

      if (this.compariosonOlderyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderforecastFullYearkWh += actualkWh;
      } else {
        this.compariosonOlderforecastFullYearkWh += forecastkWh;
      }

      if (monthIndex === lastFullMonthIndexComparison) {
        this.compariosonOlderlastFullMonthCost = this.electricityCostsComparisonDataResponse!.total_costs[monthIndex - 1]?.actual_value ?? 0;
        this.compariosonOlderlastFullMonthkWh = this.electricityCostsComparisonDataResponse!.total_consumption[monthIndex - 1]?.actual_value ?? 0;
      }
    });
  }

  loadConsumptionAndCostData() {
    if (this.consumptionAndCostsDate?.getFullYear() === null || this.consumptionAndCostsDate?.getFullYear() === undefined) {
      this.consumptionAndCostsDate = new Date();
    }

    this.consumptionAndCostsDataYear = this.consumptionAndCostsDate?.getFullYear();
    this.dashboardService.getElectricityConsumptionAndCosts(this.consumptionAndCostsDataYear).subscribe({
      next: (response) => {
        if (response) {
          this.consumptionAndCostsDataResponse = response;

          // Populate charts
          this.populateConsumptionAndCosts();
          this.populateConsumptionAndCostDoughnut();
          this.populateConsumptionAndCostsRight();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.consumptionAndCostsDataLoaded = false;

        // Populate charts
        this.populateConsumptionAndCosts();
        this.populateConsumptionAndCostDoughnut();
        this.populateConsumptionAndCostsRight();
      },
      complete: () => {
        // Mark api loading as completed
        this.consumptionAndCostsDataLoaded = true;
      }
    });
  }

  populateConsumptionAndCosts(): void {
    this.consumptionF1 = new Array(12).fill(null);
    this.consumptionF2 = new Array(12).fill(null);
    this.consumptionF3 = new Array(12).fill(null);
    this.consumptionF1Forecast = new Array(12).fill(null);
    this.consumptionF2Forecast = new Array(12).fill(null);
    this.consumptionF3Forecast = new Array(12).fill(null);

    this.costsActual = new Array(12).fill(null);
    this.costsForecast = new Array(12).fill(null);
    this.kWhActual = new Array(12).fill(null);
    this.kWhForecast = new Array(12).fill(null);

    if (!this.consumptionAndCostsDataResponse ||
      !this.consumptionAndCostsDataResponse.monthly_consumptions.length ||
      !this.consumptionAndCostsDataResponse.total_costs.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let lastActualIndex: number | null = null;

    // Hide Forecast labels if needed
    this.showForecastData = this.consumptionAndCostsDataYear >= currentYear;

    // Consumption 
    this.consumptionAndCostsDataResponse.monthly_consumptions.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const consumptionF1Actual = (monthData.month_consumption_f1 ?? 0);
      const consumptionF2Actual = (monthData.month_consumption_f2 ?? 0);
      const consumptionF3Actual = (monthData.month_consumption_f3 ?? 0);

      const consumptionF1Forecast = (monthData.month_consumption_f1_forecast ?? null);
      const consumptionF2Forecast = (monthData.month_consumption_f2_forecast ?? null);
      const consumptionF3Forecast = (monthData.month_consumption_f3_forecast ?? null);

      if (this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth) {
        this.consumptionF1[monthIndex] = consumptionF1Actual;
        this.consumptionF2[monthIndex] = consumptionF2Actual;
        this.consumptionF3[monthIndex] = consumptionF3Actual;
        this.kWhActual[monthIndex] = consumptionF1Actual + consumptionF2Actual + consumptionF3Actual;
        if (this.kWhActual[monthIndex] == 0) {
          this.kWhActual[monthIndex] = null;
        }
        lastActualIndex = monthIndex;
      } else {
        this.kWhForecast[monthIndex] = ((consumptionF1Forecast ?? 0) + (consumptionF2Forecast ?? 0) + (consumptionF3Forecast ?? 0));
        if (this.kWhForecast[monthIndex] == 0) {
          this.kWhForecast[monthIndex] = null;
        }

        this.consumptionF1Forecast[monthIndex] = consumptionF1Forecast;
        this.consumptionF2Forecast[monthIndex] = consumptionF2Forecast;
        this.consumptionF3Forecast[monthIndex] = consumptionF3Forecast;
      }
    });

    // Costs
    this.consumptionAndCostsDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const actualCost = monthData.actual_value ?? null;
      const forecastCost = monthData.forecasted_value ?? null;

      if (this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth) {
        this.costsActual[monthIndex] = actualCost;
      } else {
        this.costsForecast[monthIndex] = forecastCost;
      }
    });

    if (lastActualIndex !== null) {
      this.kWhForecast[lastActualIndex] = this.kWhActual[lastActualIndex];
      this.costsForecast[lastActualIndex] = this.costsActual[lastActualIndex];
    }

    const allConsumption = [...this.kWhActual, ...this.kWhForecast];
    const allCosts = [...this.costsActual, ...this.costsForecast];

    this.noDataDialogShowConsumptionCosts = [...allConsumption, ...allCosts].every(
      (val) => val === null || val === 0
    );

  }

  populateConsumptionAndCostDoughnut(): void {
    this.cacd_labels = ['F1', 'F2', 'F3'];
    this.cacd_showData = [0, 0, 0];

    if (!this.consumptionAndCostsDataResponse ||
      !this.consumptionAndCostsDataResponse.monthly_consumptions.length ||
      !this.consumptionAndCostsDataResponse.total_costs.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let totalCost = 0;
    let totalConsumption = 0;
    let consumptionF1 = 0, consumptionF2 = 0, consumptionF3 = 0;
    let costF1 = 0, costF2 = 0, costF3 = 0;

    // Consumption 
    this.consumptionAndCostsDataResponse.monthly_consumptions.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const isPastMonth = this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth;
      if (isPastMonth) {
        const f1 = (monthData.month_consumption_f1 ?? 0);
        const f2 = (monthData.month_consumption_f2 ?? 0);
        const f3 = (monthData.month_consumption_f3 ?? 0);

        consumptionF1 += f1;
        consumptionF2 += f2;
        consumptionF3 += f3;
        totalConsumption += f1 + f2 + f3;
      }
    });

    // Costs
    this.consumptionAndCostsDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const isPastMonth = this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth;

      const cost = isPastMonth ? monthData.actual_value ?? 0 : 0;
      totalCost += cost;
    });

    if (totalConsumption > 0) {
      costF1 = (consumptionF1 / totalConsumption) * totalCost;
      costF2 = (consumptionF2 / totalConsumption) * totalCost;
      costF3 = (consumptionF3 / totalConsumption) * totalCost;
    }

    const pricePerKWhF1 = consumptionF1 > 0 ? costF1 / consumptionF1 : 0;
    const pricePerKWhF2 = consumptionF2 > 0 ? costF2 / consumptionF2 : 0;
    const pricePerKWhF3 = consumptionF3 > 0 ? costF3 / consumptionF3 : 0;

    this.cacd_labels = [
      `F1`,
      `F2`,
      `F3`
    ];

    this.cacd_showData = [parseFloat(consumptionF1.toFixed(2)), parseFloat(consumptionF2.toFixed(2)), parseFloat(consumptionF3.toFixed(2))];
    this.cacd_totalConsumption = parseFloat(totalConsumption.toFixed(2));
  }

  populateConsumptionAndCostsRight(): void {
    this.cacr_f1data = [null, null, null];
    this.cacr_f2data = [null, null, null];
    this.cacr_f3data = [null, null, null];
    this.cacr_f1eurperkwh = 0.0;
    this.cacr_f2eurperkwh = 0.0;
    this.cacr_f3eurperkwh = 0.0;

    if (!this.consumptionAndCostsDataResponse ||
      !this.consumptionAndCostsDataResponse.monthly_consumptions.length ||
      !this.consumptionAndCostsDataResponse.total_costs.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let totalCost = 0;
    let totalConsumption = 0;
    let consumptionF1 = 0, consumptionF2 = 0, consumptionF3 = 0;
    let costF1 = 0, costF2 = 0, costF3 = 0;

    // Consumption
    this.consumptionAndCostsDataResponse.monthly_consumptions.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const isPastMonth = this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth;
      if (isPastMonth) {
        const f1 = (monthData.month_consumption_f1 ?? 0);
        const f2 = (monthData.month_consumption_f2 ?? 0);
        const f3 = (monthData.month_consumption_f3 ?? 0);

        consumptionF1 += f1;
        consumptionF2 += f2;
        consumptionF3 += f3;
        totalConsumption += f1 + f2 + f3;
      }
    });

    // Costs
    this.consumptionAndCostsDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const isPastMonth = this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth;
      const cost = isPastMonth ? monthData.actual_value ?? 0 : 0;
      totalCost += cost;
    });

    if (totalConsumption > 0) {
      costF1 = (consumptionF1 / totalConsumption) * totalCost;
      costF2 = (consumptionF2 / totalConsumption) * totalCost;
      costF3 = (consumptionF3 / totalConsumption) * totalCost;
    }

    this.cacr_f1eurperkwh = consumptionF1 > 0 ? parseFloat((costF1 / consumptionF1).toFixed(2)) : 0;
    this.cacr_f2eurperkwh = consumptionF2 > 0 ? parseFloat((costF2 / consumptionF2).toFixed(2)) : 0;
    this.cacr_f3eurperkwh = consumptionF3 > 0 ? parseFloat((costF3 / consumptionF3).toFixed(2)) : 0;

    this.cacr_f1data = [consumptionF1 > 0 ? parseFloat(consumptionF1.toFixed(2)) : null, null, null];
    this.cacr_f2data = [null, consumptionF2 > 0 ? parseFloat(consumptionF2.toFixed(2)) : null, null];
    this.cacr_f3data = [null, null, consumptionF3 > 0 ? parseFloat(consumptionF3.toFixed(2)) : null];
  }

  openMonthSelect() {
    this.costAnalysisMonth = new Date();
    this.changeMonth();
  }

  changeMonth() {
    if (this.costAnalysisMonth === undefined || this.costAnalysisYear === undefined) {
      return;
    }

    if (this.costAnalysisMonth.getFullYear() !== this.costAnalysisYear.getFullYear()) {
      this.costAnalysisYear = new Date(this.costAnalysisMonth.getFullYear(), this.costAnalysisYear.getMonth());
    }

    this.loadCostAnalysisData();
  }

  loadCostAnalysisCurrentPeriodData() {
    // Year
    if (this.costAnalysisYear?.getFullYear() === null || this.costAnalysisYear?.getFullYear() === undefined) {
      this.costAnalysisYear = new Date();
    }

    this.costAnalysisDataYear = this.costAnalysisYear?.getFullYear();

    // Month
    if (this.costAnalysisMonth === undefined) {
      this.costAnalysisDataMonth = null;
    }
    else {
      this.costAnalysisDataMonth = this.costAnalysisMonth?.getMonth() + 1;
    }

    this.dashboardService.getElectricityPeriodCostAnalysis(this.costAnalysisDataYear, this.costAnalysisDataMonth).subscribe({
      next: (response) => {
        if (response) {
          this.costAnalysisDataResponse = response;

          // Populate charts
          this.populateCostAnalysisPeriodTrend();
          this.populateCostPerKwhChart();
          this.populateCostBreakdownChart();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.costAnalysisDataLoaded = false;

        // Populate charts
        this.populateCostAnalysisPeriodTrend();
        this.populateCostPerKwhChart();
        this.populateCostBreakdownChart();
      },
      complete: () => {
        // Mark api loading as completed
        this.costAnalysisDataLoaded = true;
      }
    });
  }

  loadCostAnalysisPervoiusPeriodData() {
    // Year
    if (this.costAnalysisYear?.getFullYear() === null || this.costAnalysisYear?.getFullYear() === undefined) {
      this.costAnalysisYear = new Date();
    }

    this.costAnalysisPervoiusPeriodDataYear = this.costAnalysisYear?.getFullYear() - 1;

    // Month
    if (this.costAnalysisMonth === undefined) {
      this.costAnalysisDataMonth = null;
    }
    else {
      this.costAnalysisPervoiusPeriodDataMonth = this.costAnalysisMonth?.getMonth() + 1;
    }

    this.dashboardService.getElectricityPeriodCostAnalysis(this.costAnalysisPervoiusPeriodDataYear, this.costAnalysisPervoiusPeriodDataMonth).subscribe({
      next: (response) => {
        if (response) {
          this.costAnalysisPervoiusPeriodDataResponse = response;

          // Populate charts
          this.populateCostAnalysisPeriodTrend();
          this.populateCostPerKwhChart();
          this.populateCostBreakdownChart();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.costAnalysisPervoiusPeriodDataLoaded = false;

        // Populate charts
        this.populateCostAnalysisPeriodTrend();
        this.populateCostPerKwhChart();
        this.populateCostBreakdownChart();

      },
      complete: () => {
        // Mark api loading as completed
        this.costAnalysisPervoiusPeriodDataLoaded = true;
      }
    });
  }

  loadCostAnalysisData() {
    if (this.costAnalysisMonth != undefined && this.costAnalysisYear != undefined && this.costAnalysisMonth.getFullYear() !== this.costAnalysisYear.getFullYear()) {
      this.costAnalysisMonth = new Date(this.costAnalysisYear.getFullYear(), this.costAnalysisMonth.getMonth());
    }

    this.loadCostAnalysisCurrentPeriodData();
    this.loadCostAnalysisPervoiusPeriodData();
  }

  populateCostAnalysisPeriodTrend(): void {
    this.capd_lineCostTrendData = [0, 0];
    this.capd_barkWhData = [0, 0];
    this.capd_inputedPeriods = undefined;

    if (!this.costAnalysisDataResponse || !this.costAnalysisPervoiusPeriodDataResponse) {
      return;
    }

    this.capd_inputedPeriods = [
      this.getPeriodString(this.costAnalysisPervoiusPeriodDataYear, this.costAnalysisPervoiusPeriodDataMonth),
      this.getPeriodString(this.costAnalysisDataYear, this.costAnalysisDataMonth)
    ];

    const currentTotalCost = this.costAnalysisDataResponse.invoice_amount ?? 0;
    const previousTotalCost = this.costAnalysisPervoiusPeriodDataResponse.invoice_amount ?? 0;

    const currentTotalKwh = this.costAnalysisDataResponse.total_consumption ?? 0;
    const previousTotalKwh = this.costAnalysisPervoiusPeriodDataResponse.total_consumption ?? 0;

    this.capd_lineCostTrendData = [parseFloat(previousTotalCost.toFixed(2)), parseFloat(currentTotalCost.toFixed(2))];
    this.capd_barkWhData = [parseFloat(previousTotalKwh.toFixed(2)), parseFloat(currentTotalKwh.toFixed(2))];

    this.capd_kwhDifference = parseFloat((currentTotalKwh - previousTotalKwh).toFixed(2));
    this.capd_costDifference = parseFloat((currentTotalCost - previousTotalCost).toFixed(2));
  }

  getPeriodString(year: number, month: number | null): string {
    return month ? `${this.months[month - 1]} ${year}` : `${year}`;
  }

  populateCostPerKwhChart(): void {
    this.materialCostsDifferenceSign = '+';
    this.materialCostsDifference = 0;
    this.tmsDifferenceSign = '+';
    this.tmsDifference = 0;
    this.taxesDifferenceSign = '+';
    this.taxesDifference = 0;
    this.additionalChargesDifferenceSign = '+';
    this.additionalChargesDifference = 0;
    this.previousPeriodCostPerKwh = 0;
    this.currentPeriodCostPerKwh = 0;
    this.inputedPeriods = undefined;

    if (!this.costAnalysisDataResponse || !this.costAnalysisPervoiusPeriodDataResponse) {
      this.noDataPopUp = true;
      return;
    }

    this.inputedPeriods = [
      this.getPeriodString(this.costAnalysisPervoiusPeriodDataYear, this.costAnalysisPervoiusPeriodDataMonth),
      this.getPeriodString(this.costAnalysisDataYear, this.costAnalysisDataMonth)
    ];

    const currentTotalKwh = this.costAnalysisDataResponse.total_consumption ?? 0;
    const previousTotalKwh = this.costAnalysisPervoiusPeriodDataResponse.total_consumption ?? 0;
    const currentTotalCost = this.costAnalysisDataResponse.invoice_amount ?? 0;
    const previousTotalCost = this.costAnalysisPervoiusPeriodDataResponse.invoice_amount ?? 0;

    this.previousPeriodCostPerKwh = previousTotalKwh > 0 ? parseFloat((previousTotalCost / previousTotalKwh).toFixed(2)) : 0;
    this.currentPeriodCostPerKwh = currentTotalKwh > 0 ? parseFloat((currentTotalCost / currentTotalKwh).toFixed(2)) : 0;

    const currentTotalMaterialCost = this.costAnalysisDataResponse.total_material_costs ?? 0;
    const previousTotalMaterialCost = this.costAnalysisPervoiusPeriodDataResponse.total_material_costs ?? 0;

    const currentTmsCharges = this.costAnalysisDataResponse.tms_charges_calc ?? 0;
    const previousTmsCharges = this.costAnalysisPervoiusPeriodDataResponse.tms_charges_calc ?? 0;

    const currentTaxesCost = this.costAnalysisDataResponse.total_taxes_calc ?? 0;
    const previousTaxesCost = this.costAnalysisPervoiusPeriodDataResponse.total_taxes_calc ?? 0;

    const currentAdditionalCharges = this.costAnalysisDataResponse.additional_charges ?? 0;
    const previousAdditionalCharges = this.costAnalysisPervoiusPeriodDataResponse.additional_charges ?? 0;

    this.materialCostsDifference = previousTotalMaterialCost > 0 ? parseFloat((currentTotalMaterialCost - previousTotalMaterialCost).toFixed(2)) : 0;
    this.tmsDifference = previousTmsCharges > 0 ? parseFloat((currentTmsCharges - previousTmsCharges).toFixed(2)) : 0;
    this.taxesDifference = previousTaxesCost > 0 ? parseFloat((currentTaxesCost - previousTaxesCost).toFixed(2)) : 0;
    this.additionalChargesDifference = previousAdditionalCharges > 0 ? parseFloat((currentAdditionalCharges - previousAdditionalCharges).toFixed(2)) : 0;

    this.materialCostsDifferenceSign = this.materialCostsDifference >= 0 ? '+' : '-';
    this.tmsDifferenceSign = this.tmsDifference >= 0 ? '+' : '-';
    this.taxesDifferenceSign = this.taxesDifference >= 0 ? '+' : '-';
    this.additionalChargesDifferenceSign = this.additionalChargesDifference >= 0 ? '+' : '-';

    this.materialCostsDifference = Math.abs(this.materialCostsDifference);
    this.tmsDifference = Math.abs(this.tmsDifference);
    this.taxesDifference = Math.abs(this.taxesDifference);
    this.additionalChargesDifference = Math.abs(this.additionalChargesDifference);

    // Show no data popup
    if (this.previousPeriodCostPerKwh == 0 || this.currentPeriodCostPerKwh == 0) {
      this.noDataPopUp = true;
    }
    else {
      this.noDataPopUp = false;
    }
  }

  populateCostBreakdownChart(): void {
    this.costBreakdownData = new Array(6).fill(0);
    this.totalPricePerUnit = 0;
    let totalCost = 0;
    let totalKwh = 0;
    let totalPricePerUnit = 0;

    if (!this.costAnalysisDataResponse) {
      return;
    }

    totalCost = this.costAnalysisDataResponse.invoice_amount ?? 0;
    totalKwh = this.costAnalysisDataResponse.total_consumption ?? 0;

    if (totalKwh === 0 || totalCost === 0) {
      return;
    }

    const materialCosts = (this.costAnalysisDataResponse.total_material_costs ?? 0) / totalKwh;
    const dispatchingCost = (this.costAnalysisDataResponse.dispatch_costs ?? 0) / totalKwh;
    const tmsCharges = (this.costAnalysisDataResponse.tms_costs || (this.costAnalysisDataResponse.tms_charges_calc ?? 0)) / totalKwh;
    const taxCost = (this.costAnalysisDataResponse.total_taxes_calc || (this.costAnalysisDataResponse.total_taxes ?? 0)) / totalKwh;
    const additionalCharges = (this.costAnalysisDataResponse.additional_charges ?? 0) / totalKwh;


    this.costBreakdownData = [
      parseFloat(materialCosts.toFixed(2)),
      parseFloat(dispatchingCost.toFixed(2)),
      parseFloat(tmsCharges.toFixed(2)),
      parseFloat(taxCost.toFixed(2)),
      parseFloat(additionalCharges.toFixed(2))
    ];

    if (totalKwh > 0) {
      totalPricePerUnit = parseFloat((totalCost / totalKwh).toFixed(2));
    }

    this.totalPricePerUnit = totalPricePerUnit;
  }

  setMaxYearDate() {
    if (this.showUpgradeGeneral) {
      return;
    }

    this.dashboardService.getElectricityLatestForecastInvoice().subscribe({
      next: (response) => {
        this.electricityForecastMaxDate.setFullYear(
          response.year
        );
      },
      error: async (error) => {
        this.electricityForecastMaxDate.setFullYear(
          this.electricityForecastMaxDate.getFullYear() + 1
        );
      }
    });
  }
}
